import React, { useState } from 'react';
import RowColLayout from './RowColLayout';

const AvisoPrivacidad = ({ onCheckboxChange }) => {  // Receive callback prop
  const [isChecked, setIsChecked] = useState(false); // Track the checkbox state
  const [showAviso, setShowAviso] = useState(false); // Show/hide the Aviso de Privacidad

  const toggleCheck = () => {
    const newCheckedState = !isChecked;
    setIsChecked(newCheckedState);
    onCheckboxChange(newCheckedState);  // Pass the state back to parent component
  };

  const openAviso = () => {
    setShowAviso(true);
  };

  const closeAviso = () => {
    setShowAviso(false);
  };

  return (
    <RowColLayout>
      <div>
        <label>
          <input
            type="checkbox"
            checked={isChecked}
            onChange={toggleCheck}
          />
          <span style={{ fontSize: '0.70em' }}>
            He leído y acepto el{' '}
            <a href="#!" onClick={openAviso}>Aviso de Privacidad</a>, y autorizo el uso de mis datos personales únicamente para fines de registro y logística de la Copa de Ski Aeroméxico.
          </span>
        </label>

        {showAviso && (
          <div className="aviso-modal my-2">
            <h2 style={{ fontSize: '1.2em' }}>Aviso de Privacidad – Copa de Ski Aeroméxico</h2>
            <p style={{ fontSize: '0.85em' }}>
              El presente Aviso de Privacidad tiene como finalidad informarte sobre el uso y tratamiento de los datos personales que nos proporcionas a través del sitio de registro de la Copa de Ski Aeroméxico.
            </p>

            {/* Additional content... */}

            <button onClick={closeAviso}>Cerrar</button>
          </div>
        )}
      </div>
    </RowColLayout>
  );
};

export default AvisoPrivacidad;
